var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.subjects.filter(function (x) {
    return x.hidden == undefined || !x.hidden;
  }), function (subject, index) {
    return _c('div', {
      key: "field.".concat(index),
      staticClass: "field"
    }, [subject.type === 'text' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_c('b-form-input', {
      staticClass: "mb-2 mr-sm-2 mb-sm-0",
      attrs: {
        "id": subject.id,
        "type": "text",
        "state": _vm.v$.form["".concat(subject.id)].$error ? false : null,
        "disabled": subject.disabled,
        "placeholder": _vm.displayPlaceholder(subject)
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1)] : _vm._e(), subject.type === 'textarea' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_c('b-form-textarea', {
      staticClass: "mb-2 mr-sm-2 mb-sm-0",
      attrs: {
        "id": subject.id,
        "type": "text",
        "placeholder": _vm.displayPlaceholder(subject),
        "disabled": subject.disabled,
        "row": subject.rows,
        "state": _vm.v$.form["".concat(subject.id)].$error ? false : null
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    }), subject.memo ? _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v(" " + _vm._s(subject.memo) + " ")]) : _vm._e(), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1)] : _vm._e(), subject.type === 'select' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_c('b-form-select', {
      attrs: {
        "id": subject.id,
        "state": _vm.v$.form["".concat(subject.id)].$error ? false : null,
        "options": _vm.optionsWithPlaceholder(subject),
        "disabled": subject.disabled
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    }), subject.memo ? _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v(" " + _vm._s(subject.memo) + " ")]) : _vm._e(), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1)] : _vm._e(), subject.type === 'radio' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_c('b-form-radio-group', {
      attrs: {
        "id": subject.id,
        "options": _vm.availableOptions(subject),
        "disabled": subject.disabled,
        "state": _vm.v$.form["".concat(subject.id)].$error ? false : null
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    }), subject.memo ? _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v(" " + _vm._s(subject.memo) + " ")]) : _vm._e(), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1)] : _vm._e(), subject.type === 'checkbox' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_c('b-form-checkbox-group', {
      attrs: {
        "id": subject.id
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    }, _vm._l(_vm.availableOptions(subject), function (option, optionIndex) {
      return _c('b-form-checkbox', {
        key: index + '-' + optionIndex,
        attrs: {
          "value": option.value,
          "disabled": subject.disabled
        }
      }, [_vm._v(" " + _vm._s(option.text) + " ")]);
    }), 1), subject.memo ? _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v(" " + _vm._s(subject.memo) + " ")]) : _vm._e(), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1)] : _vm._e(), subject.type === 'datetime' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [subject.format === 'datetime' ? [_c('DynamicFormDateTimePicker', {
      attrs: {
        "id": subject.id,
        "placeholder-for-date": _vm.displayPlaceholder(subject),
        "placeholder-for-time": _vm.displayPlaceholder(subject) || ' ',
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "daily-time": subject.daily_time,
        "time-condition": subject.time_condition,
        "start-time": subject.start_time,
        "end-time": subject.end_time,
        "slot-minutes": subject.slot_minutes,
        "time-style": subject.time_style,
        "date-condition": subject.date_condition,
        "date-time-options": subject.options,
        "custom-time-options": subject.time_options,
        "optionDisabler": function optionDisabler(date, time) {
          return _vm.optionDisabler(subject, {
            date: date,
            time: time
          });
        },
        "disabled": subject.disabled
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e(), subject.format === 'date' ? [_c('DynamicFormDatePicker', {
      attrs: {
        "id": subject.id,
        "placeholder": _vm.displayPlaceholder(subject),
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "disabled": subject.disabled
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e(), subject.format === 'time' ? [_c('DynamicFormTimePicker', {
      attrs: {
        "id": subject.id,
        "placeholder": _vm.displayPlaceholder(subject) || ' ',
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "style-type": subject.time_condition,
        "start-time": subject.start_time,
        "end-time": subject.end_time,
        "slot-minutes": subject.slot_minutes,
        "custom-time-options": subject.time_options,
        "time-style": subject.time_style,
        "disabled": subject.disabled
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e(), subject.memo ? _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v(" " + _vm._s(subject.memo) + " ")]) : _vm._e(), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 2)] : _vm._e(), subject.type === 'uploader' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_c('AppFileUploader', {
      attrs: {
        "id": subject.id,
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "show-deleted-action": !subject.disabled
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })], 1)] : _vm._e(), subject.type === 'collection_select' ? [_c('CollectionSelectDashboard', {
      ref: "collection-select-".concat(subject._id),
      refInFor: true,
      attrs: {
        "subject": subject,
        "branch-id": _vm.getBranchIdByFieldId(subject.branch_field_id),
        "is-related-to-branch": !!subject.branch_field_id,
        "placeholder": _vm.displayPlaceholder(subject, '請選擇'),
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e(), subject.type === 'collection_carousel' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_c('CarouselSelection', {
      ref: "collection-carousel-".concat(subject._id),
      refInFor: true,
      attrs: {
        "id": subject.id,
        "placeholder": _vm.displayPlaceholder(subject, '請選擇'),
        "candidate-fetcher": function candidateFetcher() {
          return _vm.fetchCollectionItemsForCarousel(subject, subject.branch_field_id);
        },
        "disabled": subject.disabled || false === _vm.carouselSelectionIsEnabled(subject),
        "value-matcher": _vm.matchCandidateForCollectionCarousel,
        "has-error": _vm.v$.form["".concat(subject.id)].$error
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    }), subject.memo ? _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v(" " + _vm._s(subject.memo) + " ")]) : _vm._e(), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1)] : _vm._e(), subject.type === 'shop_selection' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": subject.title,
        "label-for": subject.id
      }
    }, [_vm.deepGet(subject, 'branch_population', 'all') === 'all' ? _c('ShopSelection', {
      ref: "shop-selection-".concat(subject._id),
      refInFor: true,
      attrs: {
        "value": _vm.deepGet(_vm.form["".concat(subject.id)], 'value'),
        "branch-provider": subject.branch_provider || '',
        "show-branch-code": subject.show_branch_code || false,
        "placeholder": subject.default_select_text || '請選擇',
        "disabled": subject.disabled,
        "api-source": "admin"
      },
      on: {
        "selected": function selected(event) {
          return _vm.handleShopSelectionChange(event, subject);
        }
      }
    }) : _vm._e(), _vm.deepGet(subject, 'branch_population', 'all') === 'subset' ? _c('ShopSubsetSelection', {
      ref: "shop-subset-selection-".concat(subject._id),
      refInFor: true,
      attrs: {
        "value": _vm.deepGet(_vm.form["".concat(subject.id)], 'value'),
        "branch-ids": subject.branch_ids || '',
        "show-parent-branches": subject.show_parent_branch_options,
        "parent-branch-population": subject.parent_branch_population || 'parent',
        "parent-branch-provider": subject.parent_branch_provider || null,
        "show-branch-code": subject.show_branch_code || false,
        "placeholder": subject.default_select_text || '請選擇',
        "disabled": subject.disabled,
        "api-source": "admin"
      },
      on: {
        "selected": function selected(event) {
          return _vm.handleShopSubsetSelectionChange(event, subject);
        }
      }
    }) : _vm._e()], 1)] : _vm._e()], 2);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }